import React from 'react';
import PropTypes from 'prop-types';
import ALink from 'tradera-components/alink/alink';
import { useUrlLocalizer } from 'tradera-lang/translate';
import styles from './details.module.scss';

export const Details = ({ url, title, transactionDate, memberUrl, alias }) => {
    const { toLocalizedUrl } = useUrlLocalizer();
    return (
        <div className="flex-grow-1 d-md-flex justify-content-between">
            <div className="d-inline-block">
                <h4 className={`mb-1 ${styles.title}`}>
                    <ALink useLink={true} href={toLocalizedUrl(url)}>
                        {title}
                    </ALink>
                </h4>
                <div className="d-flex justify-content-between">
                    <p className="size-oslo">
                        {transactionDate} |{' '}
                        <ALink
                            useLink={true}
                            href={toLocalizedUrl(memberUrl)}
                            className={`text-nowrap`}>
                            {alias}
                        </ALink>
                    </p>
                </div>
            </div>
        </div>
    );
};

Details.propTypes = {
    url: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    transactionDate: PropTypes.string.isRequired,
    memberUrl: PropTypes.string.isRequired,
    alias: PropTypes.string.isRequired
};
